import { render, staticRenderFns } from "./OrdenMassive.vue?vue&type=template&id=7555561c&scoped=true&"
import script from "./OrdenMassive.vue?vue&type=script&lang=js&"
export * from "./OrdenMassive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7555561c",
  null
  
)

export default component.exports